import {useAuth} from 'app/modules/auth'
import {CanteenMenu} from './CanteenMenu'
import {DphsMenu} from './DphsMenu'
import {DuaMenu} from './DuaMenu'
import {LecturerMenu} from './LecturerMenu'
import {SystemMenu} from './SystemMenu'
import {StudentMenu} from './StudentMenu'
import { SchoolLecturerMenu } from './SchoolLecturerMenu'

export function MenuInner() {
  const system_id = localStorage.getItem('system_id')
  const {currentUser} = useAuth()

  return (
    <>
      {system_id === '1' && <SystemMenu />}
      {system_id === '2' && <DuaMenu />}
      {system_id === '3' && <DphsMenu />}
      {system_id === '5' && <CanteenMenu />}
      {currentUser?.position == 'Lecturer' && <LecturerMenu />}
      {currentUser?.position == 'Student' && <StudentMenu />}
      {currentUser?.position == 'School Lecturer' && <SchoolLecturerMenu />}
    </>
  )
}
